var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAyurvedic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.476 12.627L14.144 13.97C13.034 12.624 10.638 15.756 9.144 13.658C8.075 12.158 7.292 11.816 5.844 10.487C4.71534 9.44834 3.598 8.47467 2.492 7.566L7.562 2.496C8.47534 3.62067 9.46034 4.76167 10.517 5.91901C13.244 8.89201 16.876 10.515 19.476 12.627Z",
    fill: "#2EA967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28476 0.757228L0.754483 6.28751C0.337794 6.7042 0.337635 7.37963 0.754129 7.79612C1.17062 8.21262 1.84605 8.21246 2.26274 7.79577L7.79302 2.26549C8.20971 1.8488 8.20987 1.17337 7.79338 0.756874C7.37688 0.34038 6.70145 0.340538 6.28476 0.757228Z",
    fill: "#2EA967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.632 25.562H20.702V26.304C20.702 26.816 19.99 27.231 19.111 27.231H13.223C12.344 27.231 11.632 26.816 11.632 26.304V25.562Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.775 14.014H29.559V15.436C29.559 18.1863 28.4664 20.824 26.5217 22.7687C24.5769 24.7135 21.9393 25.806 19.189 25.806H13.145C10.3947 25.806 7.75706 24.7135 5.81231 22.7687C3.86755 20.824 2.775 18.1863 2.775 15.436V14.014Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.53 12.289H2.805C2.05224 12.289 1.442 12.8992 1.442 13.652C1.442 14.4048 2.05224 15.015 2.805 15.015H29.53C30.2828 15.015 30.893 14.4048 30.893 13.652C30.893 12.8992 30.2828 12.289 29.53 12.289Z",
    fill: "#EEF5FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.342,
    height: 28.562,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyurvedic);
export default __webpack_public_path__ + "static/media/ayurvedic.c4b6a491212a6f1d064abc90531011d4.svg";
export { ForwardRef as ReactComponent };